// $(document).ready(function () {
//   function mjToggleProductButtons(form) {
//     var mjSelect = $(form).find(".mj_product-select");
//     var mjAtcBtn = $(form).find(".mj_product-atc__button");
//     var mjKoBtn = $(form).find(".mj_product-ko__button");
//     var mjdyBtn = $(form).find(".mj_product-delivery");

//     if (mjSelect.length) {
//       var mjSelectedOption = mjSelect.find("option:selected");
//       var mjQuantity = parseInt(mjSelectedOption.data("quantity"), 10);
//       var mjPolicy = mjSelectedOption.data("policy");

//       if (mjQuantity > 0 || (mjQuantity <= 0 && mjPolicy === "continue")) {
//         mjAtcBtn.show();
//         mjKoBtn.hide();
//         mjdyBtn.show();
//       } else if (mjQuantity <= 0 && mjPolicy === "deny") {
//         mjAtcBtn.hide();
//         mjKoBtn.show();
//         mjdyBtn.hide();
//       }
//     } else {
//       var mjQuantity = parseInt($(form).find("input[name='id']").data("quantity"), 10);
//       var mjPolicy = $(form).find("input[name='id']").data("policy");

//       if (mjQuantity > 0 || (mjQuantity <= 0 && mjPolicy === "continue")) {
//         mjAtcBtn.show();
//         mjKoBtn.hide();
//         mjdyBtn.show();
//       } else if (mjQuantity <= 0 && mjPolicy === "deny") {
//         mjAtcBtn.hide();
//         mjKoBtn.show();
//         mjdyBtn.hide();
//       }
//     }
//   }

//   $("form:has(.mj_product-select), form:not(:has(.mj_product-select))").each(function () {
//     var mjForm = this;
//     mjToggleProductButtons(mjForm);
//     $(mjForm).find(".mj_product-select").on("change", function () {
//       mjToggleProductButtons(mjForm);
//     });
//   });
// });

$(document).ready(function () {
  function mjToggleProductButtons(form) {
    var mjSelect = $(form).find(".mj_product-select");
    var mjAtcBtn = $(form).find(".mj_product-atc__button");
    var mjKoBtn = $(form).find(".mj_product-ko__button");
    var mjdyBtn = $(form).find(".mj_product-delivery");
    var mjCsBtn = $(form).find(".mj_product-delivery__cont-selling");

    if (mjSelect.length) {
      var mjSelectedOption = mjSelect.find("option:selected");
      var mjQuantity = parseInt(mjSelectedOption.data("quantity"), 10);
      var mjPolicy = mjSelectedOption.data("policy");

      if (mjQuantity > 0) {
        mjAtcBtn.show();
        mjKoBtn.hide();
        mjdyBtn.show();
        mjCsBtn.hide();
      } else if (mjQuantity <= 0 && mjPolicy === "deny") {
        mjAtcBtn.hide();
        mjKoBtn.show();
        mjdyBtn.hide();
        mjCsBtn.hide();
      } else if (mjQuantity <= 0 && mjPolicy === "continue"){
        mjAtcBtn.show();
        mjKoBtn.hide();
        mjdyBtn.hide();
        mjCsBtn.show();
      }
    } else {
      var mjQuantity = parseInt($(form).find("input[name='id']").data("quantity"), 10);
      var mjPolicy = $(form).find("input[name='id']").data("policy");

      if (mjQuantity > 0) {
        mjAtcBtn.show();
        mjKoBtn.hide();
        mjdyBtn.show();
      } else if (mjQuantity <= 0 && mjPolicy === "deny") {
        mjAtcBtn.hide();
        mjKoBtn.show();
        mjdyBtn.hide();
      } else if (mjQuantity <= 0 && mjPolicy === "continue"){
        mjAtcBtn.show();
        mjKoBtn.hide();
        mjdyBtn.hide();
        mjCsBtn.show();
      }
    }
  }

  $("form:has(.mj_product-select), form:not(:has(.mj_product-select))").each(function () {
    var mjForm = this;
    mjToggleProductButtons(mjForm);
    $(mjForm).find(".mj_product-select").on("change", function () {
      mjToggleProductButtons(mjForm);
    });
  });
});
